<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="parking">
    <div class="condition">
      <el-col :xs="24" :md="19">
        <div class="condition_div">

          <el-form :model="form" status-icon ref="form" label-width="100px" class="demo-form">
            <el-col :xs="24" :lg="12">
              <el-form-item label="入场时间：" prop="start_date">
                <el-date-picker v-model="start_date" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" style="width:100%" value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="inOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :lg="12">
              <el-form-item label="离场时间:" prop="end_date">
                <el-date-picker v-model="end_date" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" style="width:100%" value-format="yyyy-MM-dd HH:mm:ss"
                  :picker-options="outOptions">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="场地:" prop="car_no ">
                <loadSelect ref="loadSelect"
                  :obj="{modelVal:form.platId,disabled:false,optionVal:'plat_id',optionName:'plat_name',placeholder:'请选择' }"
                  :url="'premises/getList'" :formData="formFieldData" :parameter="false" @changeFn="changePlatField">
                </loadSelect>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="停车时间:" prop="stay_duration ">
                <el-select v-model="form.stay_duration " placeholder="请选择" style="width:100%">
                  <el-option v-for="item in stopTimeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="车辆类型:" prop="car_type ">
                <el-select v-model="form.car_type " placeholder="请选择" style="width:100%">
                  <el-option v-for="item in carTypeList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="当前状态:" prop="current_state ">
                <el-select v-model="form.current_state " placeholder="请选择" style="width:100%">
                  <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="离场操作:" prop="out_reason ">
                <el-select v-model="form.out_reason " placeholder="请选择" style="width:100%">
                  <el-option v-for="item in operationList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="操作员:" prop="operator_user ">
                <loadSelect ref="loadSelect"
                  :obj="{modelVal:form.operator_user,disabled:false,optionVal:'bd_user_id',optionName:'nick_name',placeholder:'请选择' }"
                  :url="'premises/getOperatorList'" :formData="formOperatorData" :parameter="false"
                  @changeFn="changePlatDeviceId"></loadSelect>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="6">
              <el-form-item label="车牌号:" prop="car_no ">
                <el-input type="text" v-model="form.car_no " autocomplete="off" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>

          </el-form>
        </div>
      </el-col>
      <el-col :xs="24" :md="5" style="text-align: center;">
        <div class="btn">
          <el-button type="primary" @click="reset()">清空筛选</el-button>
          <el-button type="primary" @click="query()">查询</el-button>
        </div>
      </el-col>

    </div>
    <el-col :xs="24">
      <div class="text" v-if="totalMessage">
        {{totalMessage&&showDate(totalMessage)  }}，
        在场车辆 {{totalMessage&&totalMessage.total_online_car||0}} 辆，
        其中历史在场车辆{{totalMessage&&totalMessage.total_past_online_car||0}}辆，
        入场车辆{{totalMessage&&totalMessage.total_in_car||0}}辆，
        出场车辆{{totalMessage&&totalMessage.total_out_car||0}}辆，
        合计收取停车费<span>{{(totalMessage&&(totalMessage.total_income*1)||0).toFixed(2)}}元</span>
        （人工：<span>{{(totalMessage&&(totalMessage.total_income_by_hand*1)||0).toFixed(2)}}元</span>）。
      </div>
    </el-col>

    <el-table :data="tableData" style="width: 100%" ref="inTable">
      <el-table-column prop="car_no" label="车牌号" min-width="100" align="center" fixed>
      </el-table-column>
      <el-table-column prop="in_time" label="入场时间" min-width="180" align="center">
      </el-table-column>
      <el-table-column prop="current_state_desc" label="当前状态" min-width="80" align="center">
      </el-table-column>
      <el-table-column prop="out_time" label="离场时间" min-width="180" align="center">
      </el-table-column>
      <el-table-column prop="stop_time_msg" label="停车时间" min-width="180" align="center">
      </el-table-column>
      <el-table-column prop="record_type_desc" label="车辆类别" min-width="100" align="center">
      </el-table-column>
      <el-table-column prop="reason_type_msg" label="离场操作" min-width="100" align="center">
      </el-table-column>
      <el-table-column prop="let_go_user" label="操作员" min-width="100" align="center">
      </el-table-column>
      <!-- <el-table-column prop="reason_content" label="特殊离场原因" min-width="150" align="center">
      </el-table-column> -->
      <el-table-column prop="pay_fee" label="停车费" min-width="100" align="center">
      </el-table-column>
      <el-table-column prop="pay_fee" label="操作" min-width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <!-- 临停的才可以放行 -->
          <tooltip :title="'放行'" v-if="scope.row.pay_at == null && scope.row.record_type ==0 && !scope.row.out_time">
            <img src="../../assets/open.png" style="width: 23px;" @click="collectMoneyFn(scope.row)" />
          </tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :page="form.page"
      :size="form.size" :total="total"></pagination>
    <!-- 收费放行 -->
    <el-dialog title="收费放行" :visible.sync="collect" :show-close="false" :center="true" width="400px">
      <el-form :model="collectMoneyForm" status-icon ref="collectMoneyForm" label-width="100px"
        class="demo-collectMoney">
        <el-form-item label="设备：">
          <loadSelect ref="loadSelect"
            :obj="{modelVal:collectMoneyForm.platDeviceId,disabled:false,optionVal:'plat_device_id',optionName:'device_name',placeholder:'请选择' }"
            :url="'premises/getDeviceList'" :formData="formDeviceData" :parameter="{  platId: this.platId}"
            @changeFn="changeDeviceId"></loadSelect>
        </el-form-item>
        <div class="dialog_btn">
          <el-button round @click="collect = false">取消</el-button>
          <el-button type="primary" round @click="collectMoney('collectMoneyForm')">确定放行</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import Util from "../../Util"
  import pagination from "../../components/pagination"
  import tooltip from "../../components/tooltip"
  import loadSelect from "../../components/loadSelect"
  export default {
    components: {
      pagination,
      tooltip,
      loadSelect
    },
    data() {
      return {

        total: 0,
        form: {
          stay_duration: "",
          car_type: "",
          current_state: "",
          out_reason: "",
          operator_user: "",
          car_no: "",
          platId: "",
          page: 1,
          size: 10,
        },
        start_date: "",
        end_date: "",
        tableData: [],
        stopTimeList: [{
          value: "15",
          label: '15分钟内'
        }, {
          value: "60",
          label: '1小时内'
        }, {
          value: "60-120",
          label: '1-2小时'
        }, {
          value: "120-240",
          label: '2-4小时'
        }, {
          value: "240-480",
          label: '4-8小时'
        }, {
          value: "480-1440",
          label: '8-24小时'
        }, {
          value: "1440-2880",
          label: '1-2天'
        }, {
          value: "2880-2881",
          label: '2天以上'
        }, ],
        carTypeList: [{
          value: 1,
          label: '临停车'
        }, {
          value: 2,
          label: '月租车'
        }],
        statusList: [{
          value: 1,
          label: '在场'
        }, {
          value: 2,
          label: '离场'
        }, ],
        operationList: [
          //     {
          //   value: 1,
          //   label: '扫码'
          // }, {
          //   value: 2,
          //   label: '岗亭'
          // },
          {
            value: 3,
            label: '岗亭特殊费用'
          }, {
            value: 4,
            label: '岗亭特殊原因'
          },
        ],
        totalMessage: null,
        platDeviceList: [],
        fieldList: [],
        collectMoneyForm: {
          platDeviceId: ""
        },
        collect: false,
        thisRecord: null,
        inOptions: {
          disabledDate(v) {
            return v.getTime() > new Date().getTime();
          }
        },
        outOptions: {
          disabledDate(v) {
            return v.getTime() > new Date().getTime();
          }
        },
        formFieldData: { //场地分页
          page: 1,
          size: 10
        },
        formDeviceData: { //设备分页
          page: 1,
          size: 10
        },
        platId: "", //场地编号
        formOperatorData: { //操作员分页
          page: 1,
          size: 10
        },
      }
    },
    computed: {
      fullscreenLoading() {
        return this.$store.state.fullscreenLoading;
      },
      userInfo() {
        return this.$store.state.userInfo;
      },
    },
    watch: {},
    mounted() {
      this.getList()
    },
    methods: {
      changePlatDeviceId(val) {
        this.form.operator_user = val
      },
      changePlatField(val) {
        this.form.platId = val
      },
      changeDeviceId(val) {
        this.collectMoneyForm.platDeviceId = val
      },
      //   清空筛选
      reset() {
        this.start_date = ""
        this.end_date = ""
        this.form = {
          stay_duration: "",
          car_type: "",
          current_state: "",
          out_reason: "",
          operator_user: "",
          car_no: "",
          platId: ""
        }
      },
      query() {
        this.getList("query")
      },
      getList(val) {
        this.$refs['form'].validate((valid) => {
          if (valid) {
            if (this.start_date) {
              this.form.car_in_start_date = this.start_date[0]
              this.form.car_in_end_date = this.start_date[1]

            } else {
              this.form.car_in_start_date = ""
              this.form.car_in_end_date = ""
            }
            if (this.end_date) {
              this.form.car_out_start_date = this.end_date[0]
              this.form.car_out_end_date = this.end_date[1]
            } else {
              this.form.car_out_start_date = ""
              this.form.car_out_end_date = ""
            }
            if (val) {
              this.form.page = 1
            }
            this.$http.post(`${Util.searchURL}parking/getStopRecordList`, this.form).then(
              res => {
                if (res.data.code === 200) {
                  let d = res.data.data
                  this.totalMessage = d.count_info || null
                  this.tableData = d.data
                  this.total = d.pageInfo.total
                }
              },
              err => {
                this.$store.commit("setParam", {
                  fullscreenLoading: false
                });
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      collectMoneyFn(val) {
        this.thisRecord = val
        this.collect = true
        this.collectMoneyForm.platDeviceId = ""
        this.platDeviceList = []
        this.platId = val.plat_id
        this.formDeviceData = {
            page: 1,
            size: 10
          },
          this.searchDeviceVal = ""
      },
      //   收费放行
      collectMoney(val) {
        this.$http.post(`${Util.operateURL}device/payOpenDo`, {
          orderId: this.thisRecord.order_id,
          payFee: this.thisRecord.pay_fee,
          stopTimeLen: this.thisRecord.stop_time_len,
          platDeviceId: this.collectMoneyForm.platDeviceId
        }).then(
          res => {
            if (res.data.code === 200) {
              Util.message("suc", res.data.desc)
            } else {
              Util.message("err", res.data.desc)
            }
          },
          err => {

            console.log(err);
          }
        );
      },
      //   每页页数改变时
      handleSizeChange(val) {
        this.form.page = 1
        this.form.size = val
        this.getList()
      },
      //   改变页数时
      handleCurrentChange(val) {
        this.form.page = val
        this.getList()

      },
      showDate(val) {
        let text
        if (val.start_date == val.end_date) {
          text = val.start_date
        } else {
          text = val.start_date + "-" + val.end_date
        }
        return text
      },
      forceUpdate() {
        this.$forceUpdate()
      },

    }

  }

</script>

<style lang="less" scoped>
  .parking {
    .text {
      margin: 20px 0px 40px 0px;

      span {
        color: red;
      }
    }

    .btn {
      button {
        padding: 10px 20px;
      }
    }

    .el-pagination {
      padding: 15px;
      background: #fff;
    }

    .dialog_btn {
      margin-top: 54px;
      text-align: center;

      button {
        width: 108px;
        padding: 6px 25px;
        margin-bottom: 5px;
      }
    }
  }

  @media (min-width: 1200px) {
    .btn {
      position: relative;
      top: 126px;
    }
  }

  @media (max-width: 1200px) {
    .btn {
      position: relative;
      top: 314px;
    }
  }

  @media (max-width: 990px) {
    .btn {
      position: relative;
      top: 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/page/parking/index.vue